(function () {
  function initShareOverlay() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery || gallery.querySelector('.velora-share-overlay-btn')) return;

    gallery.style.position = 'relative';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'velora-share-overlay-btn';
    btn.setAttribute('aria-label', 'Share this product');
    btn.style.cssText = 'position:absolute;top:12px;right:12px;z-index:5;width:40px;height:40px;border-radius:50%;background:rgba(255,255,255,0.92);border:none;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 1px 4px rgba(0,0,0,0.15);';
    btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0d1b2a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line></svg>';

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var shareUrl = window.location.href;
      var shareTitle = document.title;
      if (navigator.share) {
        navigator.share({ title: shareTitle, url: shareUrl }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(shareUrl).then(function () {
          var original = btn.innerHTML;
          btn.innerHTML = '<span style="font-size:10px;font-weight:600;color:#0d1b2a;">Copied!</span>';
          setTimeout(function () {
            btn.innerHTML = original;
          }, 2000);
        });
      } else {
        window.prompt('Copy this link:', shareUrl);
      }
    });

    gallery.appendChild(btn);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShareOverlay);
  } else {
    initShareOverlay();
  }
})();
